import { createSlice } from "@reduxjs/toolkit"
import {
    getStaticMaintenanceList,
    getStaticMaintenance,
    deleteStaticMaintenance,
    addStaticMaintenance,
    updateStaticMaintenance,
    getStaticMaintenanceDetails
} from "store/actions/staticMaintenanceAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  staticMaintenanceList: [],
  staticMaintenance: [],
  staticMaintenancDetails: {},
}

const usersSlice = createSlice({
  name: "staticMaintenance",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL STATIC MAINTENANCE
    builder
      .addCase(getStaticMaintenance.pending, state => {
        state.loading = true
      })
      .addCase(getStaticMaintenance.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.staticMaintenance = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getStaticMaintenance.rejected, (state, action) => {
        state.loading = false
      })

    // GET ALL STATIC MAINTENANCE LIST
    builder
      .addCase(getStaticMaintenanceList.pending, state => {
        state.loading = true
      })
      .addCase(getStaticMaintenanceList.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.staticMaintenanceList = data
        }
      })
      .addCase(getStaticMaintenanceList.rejected, (state, action) => {
        state.loading = false
      })

    // DELETE STATIC MAINTENANCE
    builder
      .addCase(deleteStaticMaintenance.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteStaticMaintenance.fulfilled, (state, action) => {
        const { status, msg } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.staticMaintenance = state.staticMaintenance.filter(item => item._id !== id)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteStaticMaintenance.rejected, (state, action) => {
        state.isLoading = false
      })

    //  ADD STATIC MAINTENANCE
    builder
      .addCase(addStaticMaintenance.pending, state => {
        state.isLoading = true
      })
      .addCase(addStaticMaintenance.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addStaticMaintenance.rejected, (state, action) => {
        state.isLoading = false
      })

    // UPDATE STATIC MAINTENANCE
    builder
      .addCase(updateStaticMaintenance.pending, state => {
        state.isLoading = true
      })
      .addCase(updateStaticMaintenance.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateStaticMaintenance.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET STATIC MAINTENANCE DETAILS
    builder
      .addCase(getStaticMaintenanceDetails.pending, state => {
        state.loading = true
        state.staticMaintenancDetails = {}
      })
      .addCase(getStaticMaintenanceDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.staticMaintenancDetails = data
        }
      })
      .addCase(getStaticMaintenanceDetails.rejected, (state, action) => {
        state.loading = false
      })

  },
})

export default usersSlice.reducer